import { render } from "./CompanySettings.vue?vue&type=template&id=6760075d&scoped=true"
import script from "./CompanySettings.vue?vue&type=script&lang=js"
export * from "./CompanySettings.vue?vue&type=script&lang=js"

import "./CompanySettings.vue?vue&type=style&index=0&id=6760075d&lang=scss"
import "bootstrap/dist/css/bootstrap.css?vue&type=style&index=1&id=6760075d&scoped=true&lang=css&external"
import "@/assets/styles/beneficiary.css?vue&type=style&index=2&id=6760075d&scoped=true&lang=css&external"
import "./CompanySettings.vue?vue&type=style&index=3&id=6760075d&scoped=true&lang=css"
import "./CompanySettings.vue?vue&type=style&index=4&id=6760075d&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6760075d"]])

export default __exports__